import PropTypes from 'prop-types';
import React from 'react';

const Jumbotron = ({
  title,
  text,
  children,
  bgClass = 'bg-light',
  paddingClass = 'p-5',
}) => (
  <div className={`${paddingClass} mb-4 ${bgClass} rounded-3`}>
    <div className="container-fluid py-5">
      <h1 className="display-5 fw-bold">{title}</h1>
      <p className="col-md-8 fs-4">{text}</p>
      {children}
    </div>
  </div>
);

Jumbotron.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.node,
  bgClass: PropTypes.string,
  paddingClass: PropTypes.string,
};

export default Jumbotron;
